export const initialState = {
  summary: {
    data: [],
    isLoading: false,
  },
};
